import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=3117ba57&"
import script from "./SwitchAccount.vue?vue&type=script&lang=js&"
export * from "./SwitchAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports